import { onUnmounted } from 'vue';

/**
 * Loads and plays `.lazy-video[data-src]` videos as they approach the viewport.
 */
export function useLazyVideos() {
  let videoObserver = null;

  const setupLazyVideos = () => {
    videoObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const video = entry.target;
          const src = video.dataset.src;
          if (src && !video.src) {
            video.src = src;
            video.load();
            video.play().catch(() => {});
          }
          videoObserver.unobserve(video);
        }
      });
    }, { rootMargin: '200px' });

    document.querySelectorAll('.lazy-video[data-src]').forEach(video => {
      videoObserver.observe(video);
    });
  };

  onUnmounted(() => {
    if (videoObserver) videoObserver.disconnect();
  });

  return { setupLazyVideos };
}
